// Catat Hasil Saya (Operator Bordir): tombol kartu, cari/scan nomor pesanan, panel Owner/Admin.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import ScanMockupModal from "./scan_mockup";
import { ClaimDialog, claimInvalid, claimText, errText } from "./bordir_claim_dialog";

export { ClaimDialog, claimInvalid };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Pekerjaan Bordir Offline milik operator lain yang MENUGASKAN saya (Bagi Pekerjaan) → tampil di "Sedang Dikerjakan" saya.
export function isSharedBordir(c, operator, opName) {
  const p = c?.product || {};
  const t = p.bordir_team || {};
  return operator?.team === "Operator Bordir" && c?.stage === "Bordir" && p.production_stage === "Bordir"
    && !!p.production_pic && p.production_pic !== opName && !t.waiting
    && ((t.active || []).includes(opName) || (t.assigned || []).includes(opName));
}

// Ringkasan sisa untuk banyak kartu sekaligus (1 permintaan). Kunci: "nota::produk".
export function useClaimSummary(items, on = true) {
  const [map, setMap] = useState({});
  const sig = items.map(x => `${x.order_number}::${x.product_id}`).join("|");
  const load = useCallback(() => {
    if (!on || !sig) return;
    const list = sig.split("|").map(k => { const [order_number, product_id] = k.split("::"); return { order_number, product_id }; });
    axios.post(`${API}/bordir-claims/summary`, { items: list.slice(0, 80) }, { withCredentials: true })
      .then(r => setMap(r.data.items || {})).catch(() => {});
  }, [sig, on]);
  useEffect(() => { load(); }, [load]);
  return [map, load];
}

export const claimDone = (info) => info?.capacity != null && info.remaining <= 0;

export function ClaimSisa({ info, holder, testid }) {
  if (!info) return null;
  const who = (info.operators || []).length ? `Dicatat: ${info.operators.join(", ")}` : "";
  const sisa = info.capacity == null ? "Titik belum tercatat" : claimDone(info) ? "Sisa habis" : `Sisa ${info.remaining} titik`;
  return <span className="queue-status-label" style={{ color: claimDone(info) ? "#15803d" : "#1e40af" }} data-testid={testid}>
    {holder ? `Dikerjakan ${holder} · ` : ""}{sisa}{who ? ` · ${who}` : ""}</span>;
}

export function ClaimButton({ orderNumber, productId, label, testid, onChanged, info }) {
  const [open, setOpen] = useState(false);
  const done = claimDone(info);
  return <>
    <button type="button" className="soft-btn small-btn" title={done ? "Semua titik sudah dicatat — pencatatan dikunci, buka untuk Selesai Bordir" : ""}
      onClick={e => { e.stopPropagation(); setOpen(true); }} data-testid={testid || `claim-open-${productId}`}>{done ? "Sisa habis · Selesai Bordir" : "Catat Hasil Saya"}</button>
    {open && <ClaimDialog orderNumber={orderNumber} productId={productId} label={label} onClose={() => setOpen(false)} onChanged={onChanged} />}
  </>;
}

export function ClaimLookup() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [pick, setPick] = useState(null);
  const [cam, setCam] = useState(false);
  const search = async (num) => {
    try { setItems((await axios.get(`${API}/bordir-claims/lookup`, { params: { q: num }, withCredentials: true })).data.items); }
    catch (er) { setItems([]); window.alert(errText(er)); }
  };
  const find = (e) => { e.preventDefault(); search(q.trim()); };
  const scanned = (num) => { setCam(false); if (num) { setQ(num); search(String(num).trim()); } };
  return <div style={{ margin: "8px 0", display: "grid", gap: 6 }} data-testid="claim-lookup">
    <form onSubmit={find} style={{ display: "flex", gap: 6 }}>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Scan / ketik nomor pesanan untuk Catat Hasil Saya" style={{ flex: 1, padding: "8px 10px" }} data-testid="claim-lookup-input" />
      <button className="primary small-btn" disabled={q.trim().length < 3} data-testid="claim-lookup-submit">Cari</button>
      <button type="button" className="soft-btn small-btn" onClick={() => setCam(true)} data-testid="claim-lookup-camera">Kamera</button>
    </form>
    {cam && <ScanMockupModal open onClose={() => setCam(false)} onOpenOrder={scanned} searchOnly title="Scan untuk Catat Hasil Saya" />}
    {items && items.length === 0 && <small className="muted" data-testid="claim-lookup-empty">Pesanan Bordir tidak ditemukan.</small>}
    {(items || []).map(x => <div key={x.product_id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }} data-testid={`claim-lookup-item-${x.product_id}`}>
      <span style={{ flex: 1 }}><b>{x.order_number}</b> · {x.product_name}{!x.eligible && <span style={{ color: "#b91c1c" }}> — {x.reason}</span>}</span>
      {x.eligible && <button className="soft-btn small-btn" onClick={() => setPick(x)} data-testid={`claim-lookup-open-${x.product_id}`}>Catat Hasil Saya</button>}
    </div>)}
    {pick && <ClaimDialog orderNumber={pick.order_number} productId={pick.product_id} onClose={() => setPick(null)} />}
  </div>;
}

export function ClaimsPendingPanel() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => axios.get(`${API}/bordir-claims/pending`, { withCredentials: true }).then(r => setD(r.data)).catch(() => setD(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!d || (!d.claims.length && !d.finish_requests.length && !(d.unregistered || []).length)) return null;
  const validateAll = async () => {
    if (!window.confirm(`Ubah ${d.claims.length} hasil lama "Menunggu Validasi" menjadi Tercatat? Hasil langsung masuk performa operator.`)) return;
    try { const r = await axios.post(`${API}/bordir-claims/validate-all-pending`, { reason: "Ubah sekali ke Tercatat (Owner)" }, { withCredentials: true }); window.alert(`${r.data.validated} hasil diubah ke Tercatat`); load(); }
    catch (e) { window.alert(errText(e)); }
  };
  const validate = async (c) => {
    const reason = window.prompt(`Validasi klaim ${c.operator_name} ${claimText(c)}? Catatan:`, "");
    if (reason === null) return;
    try { await axios.post(`${API}/bordir-claims/${c.id}/validate`, { reason }, { withCredentials: true }); load(); } catch (e) { window.alert(errText(e)); }
  };
  return <section style={{ border: "1px solid #fcd34d", background: "#fffbeb", borderRadius: 10, padding: 10, margin: "8px 0", display: "grid", gap: 6 }} data-testid="claims-pending-panel">
    <b>Klaim Hasil Bordir — Perlu Tindakan</b>
    {d.claims.length > 0 && <button className="primary small-btn" onClick={validateAll} data-testid="claims-validate-all">Ubah semua ke Tercatat ({d.claims.length})</button>}
    {(d.unregistered || []).map(x => <div key={`u-${x.order_number}-${x.product_id}`} style={{ display: "flex", gap: 6, fontSize: 12, alignItems: "center" }} data-testid={`claims-unreg-${x.product_id}`}>
      <span style={{ flex: 1 }}>{x.order_number} · {x.product_name} · Titik pesanan belum terdaftar · tercatat {x.used} titik{x.declared_titik ? ` · titik/baju diisi ${x.declared_titik.by}: ${x.declared_titik.titik}` : ""}</span>
      <button className="soft-btn small-btn" onClick={() => setOpen(x)} data-testid={`claims-unreg-open-${x.product_id}`}>Periksa</button>
    </div>)}
    {d.claims.map(c => <div key={c.id} style={{ display: "flex", gap: 6, fontSize: 12, alignItems: "center" }} data-testid={`claims-pending-${c.id}`}>
      <span style={{ flex: 1 }}>{c.order_number} · {c.operator_name} · {claimText(c)} · Menunggu Validasi</span>
      <button className="soft-btn small-btn" onClick={() => validate(c)} data-testid={`claims-validate-${c.id}`}>Validasi</button>
      <button className="soft-btn small-btn" onClick={() => setOpen(c)} data-testid={`claims-open-${c.id}`}>Buka</button>
    </div>)}
    {d.finish_requests.map(x => <div key={x.product_id} style={{ display: "flex", gap: 6, fontSize: 12, alignItems: "center" }} data-testid={`claims-finish-${x.product_id}`}>
      <span style={{ flex: 1 }}>{x.order_number} · minta Selesai dengan Selisih ({x.finish_request.gap}) — {x.finish_request.by}: {x.finish_request.reason}</span>
      <button className="soft-btn small-btn" onClick={() => setOpen(x)} data-testid={`claims-finish-open-${x.product_id}`}>Periksa</button>
    </div>)}
    {open && <ClaimDialog orderNumber={open.order_number} productId={open.product_id} onClose={() => { setOpen(null); load(); }} />}
  </section>;
}
